export const SUBJECT_NAME_MAX_LENGTH = 20;
export const TEACHER_NAME_MAX_LENGTH = 16;
